import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

export const getRawUrl = (baseUrl: string) => `${baseUrl}/rest/greenhopper/1.0/rapidviews/recent`;

export const getUrl = (baseUrl: string, count: number) =>
	`${getRawUrl(baseUrl)}?maxResults=${count}`;

export type RecentBoard = {
	id: string;
	name: string;
	isSimpleBoard: boolean;
	location: {
		locationKey: string;
		displayText: string;
		avatarUrl: string;
		type: string;
		accountId?: string;
	};
};

export type Response = {
	views: RecentBoard[];
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, count: number): Promise<Response> => {
	const url = getUrl(baseUrl, count);
	const response = await fetch(url, getDefaultOptions(url));
	if (response.ok) {
		return response.json();
	}

	const text = await response.text();
	throw new FetchError(response.status, text);
};
